<!--<div id="playerElement" style="width:100%; height:0; padding:0 0 56.25% 0"></div>-->

<video width="400" height="300" controls="controls">
    <source [src]="url" type='video/mp4; codecs="avc1.42E01E, mp4a.40.2"'>
</video>
